import { httpsCallable } from 'firebase/functions';

import { functions } from '../firebase/config';

const getHistoryCallable = httpsCallable(functions, 'getDriverTrackHistory');
const getRideRouteCallable = httpsCallable(functions, 'getRideActualRoute');
const getGpsAnomalyEventsCallable = httpsCallable(functions, 'getGpsAnomalyEvents');

const unwrapCallable = async (callable, payload) => {
  const result = await callable(payload);
  return result.data || {};
};

export const getDriverTrackHistory = (filters) => unwrapCallable(getHistoryCallable, filters);

export const getRideActualRoute = (rideId) => unwrapCallable(getRideRouteCallable, { rideId });

// Protokollierte GPS-Auffaelligkeiten (gps_manipulation_erkennung_konzept.md).
// Gleicher Weg wie die Fahrerhistorie: ueber eine Callable, weil die Ereignisse
// Koordinaten enthalten und serverseitig auf den Mandanten gescopt werden.
export const getGpsAnomalyEvents = (filters) => unwrapCallable(getGpsAnomalyEventsCallable, filters);
